<template>
	<div :class="rootClass">
		<PageHeader>
			<StatisticsLinkList />
		</PageHeader>
		<ManagingSection :isTable="true">
			<HorizontalSearch :blockElem="true" @init="init" @search="search">
				<SelectInput
					ref="period"
					label="기간"
					:usePeriod="true"
					@change="periodChange"
				/>
				<RadioList
					v-model="type"
					:radioList="typeList"
					ver="3"
					title="푸시 타입"
				/>
				<template v-slot:optionalButton="{ className }">
					<button
						type="button"
						:class="['btn-excel', className]"
						v-text="'EXCEL 다운로드'"
						@click="excelDown"
					/>
				</template>
			</HorizontalSearch>
		</ManagingSection>
		<ManagingSection :isTable="true">
			<table :class="`table-main ${rootClass}__table`">
				<thead>
					<tr v-for="(thList, idx) in thBundle" :key="idx">
						<th
							v-for="(item, idx2) in thList"
							:key="idx2"
							:rowspan="item.rowspan"
							:colspan="item.colspan"
							:class="item.class"
							v-text="item.text"
						/>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(thList, idx) in list" :key="idx">
						<td
							v-for="(item, idx2) in thList"
							:key="`${idx}${idx2}`"
							:class="item.class"
						>
							<router-link
								v-if="item.link"
								:to="item.link"
								class="link"
								>{{ item.text }}</router-link
							>
							<template v-else>{{ item.text }}</template>
						</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				@to="paging($event.offset)"
				:total-item="totalCount"
				:offset="offset"
				:limit="limit"
			/>
		</ManagingSection>
	</div>
</template>
<script>
	import moment from 'moment';
	import util from '@/util';
	import Excel from 'exceljs';
	import PageHeader from '@/components/PageHeader.vue';
	import StatisticsLinkList from '@/components/operation/StatisticsLinkList.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import HorizontalSearch from '@/components/HorizontalSearch.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import RadioList from '@/components/RadioList.vue';

	export default {
		name: 'PushStatistics',
		components: {
			PageHeader,
			StatisticsLinkList,
			ManagingSection,
			HorizontalSearch,
			PaginationBox,
			SelectInput,
			RadioList,
		},
		data() {
			return {
				rootClass: 'push-statistics',
				limit: 20,
				offset: 0,
				startAt: null,
				endAt: null,
				typeList: [
					{ id: null, value: '전체' },
					{ id: 'target', value: '수동' },
					{ id: 'auto', value: '자동' },
				],
				type: null,
				totalCount: 0,
				lastUrl: '',
				list: [],
				params: null,
			};
		},
		methods: {
			currency(number) {
				return util.currency(String(number));
			},
			setCellClass(id) {
				return `${this.rootClass}__${id}-cell`;
			},
			periodChange({ from, to }) {
				this.startAt = from;
				this.endAt = to;
			},
			setFilter({ limit, offset, startAt, endAt, type } = {}) {
				if (limit) {
					this.limit = Number(limit);
				}
				if (offset) {
					this.offset = Number(offset);
				}
				this.$refs.period.changePeriod({
					from: startAt || moment().date(1).format('YYYY-MM-DD'),
					to: endAt || moment().format('YYYY-MM-DD'),
				});
				this.type = this.typeList.some(item => item.id === type)
					? type
					: this.typeList[0].id;
			},
			getDisplayCount(messageAggregateList) {
				const push =
					messageAggregateList?.find(
						item => item.path === 'message_push'
					) || {};
				const message =
					messageAggregateList?.find(
						item => item.path === 'message_box'
					) || {};
				let totalCount = 0;
				const countList = [
					push.aosDisplayCount,
					push.iosDisplayCount,
					message.aosDisplayCount,
					message.iosDisplayCount,
				].map((count = 0) => {
					totalCount += count;
					return {
						text: this.currency(count),
						class: this.setCellClass('dp-cnt'),
					};
				});
				return {
					countList,
					totalCount,
				};
			},
			async getList(isAll) {
				const params = { ...this.params };
				if (!params.startAt || !params.endAt) {
					throw {
						status: 'validation',
						msg: '기간을 입력해주세요.',
					};
				}
				if (isAll) {
					delete params.limit;
					delete params.offset;
				}
				const { config, data } = await this.$axiosAdmin2.get(
					'/api/tracking/message',
					{ params }
				);
				this.lastUrl = config.url;
				return {
					...data,
					data: data.data.map(
						({ messageAggregateList, noti, notiSchedule }) => {
							const { countList, totalCount } =
								this.getDisplayCount(messageAggregateList);
							return [
								{
									text: moment(
										notiSchedule.sentDate,
										'X'
									).format('YYYY-MM-DD HH:mm:ss'),
									class: this.setCellClass('date'),
								},
								{
									text: `${noti.idNoti}-${notiSchedule.idNotiSchedule}`,
									class: this.setCellClass('id'),
								},
								{
									text: noti.notiText,
									class: this.setCellClass('content'),
									link: `/manage/push-inquiry/${noti.idNoti}/${notiSchedule.idNotiSchedule}`,
								},
								{
									text:
										notiSchedule.type === 'all'
											? '전체'
											: '타겟',
									class: this.setCellClass('type'),
								},
								{
									text: notiSchedule.registerCnt
										? this.currency(
												notiSchedule.registerCnt || 0
											)
										: '-',
									class: this.setCellClass('target'),
								},
								{
									text:
										notiSchedule.type === 'auto'
											? '자동'
											: '수동',
									class: this.setCellClass('type'),
								},
								...countList,
								totalCount
									? {
											text: '상세보기',
											class: this.setCellClass('detail'),
											link: `/operation/statistics/push/${noti.idNoti}`,
										}
									: {
											text: null,
											class: this.setCellClass('detail'),
										},
							];
						}
					),
				};
			},
			async setList() {
				try {
					const type = this.type ? { type: this.type } : {};
					this.params = {
						limit: this.limit,
						offset: this.offset,
						startAt: this.startAt
							? moment(this.startAt, 'YYYY-MM-DD').format('X')
							: null,
						endAt: this.endAt
							? moment(this.endAt, 'YYYY-MM-DD')
									.add(1, 'day')
									.add(-1, 'millisecond')
									.format('X')
							: null,
						...type,
					};
					const { totalCount, data } = await this.getList();
					this.totalCount = totalCount;
					this.list = data;
				} catch (err) {
					if (err.status === 'validation') {
						console.error(err.status);
						alert(err.msg);
					} else {
						console.error(err);
						alert(
							'목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
						);
					}
				}
			},
			setQuery() {
				const query = {
					limit: this.limit,
					offset: this.offset,
					startAt: this.startAt,
					endAt: this.endAt,
					type: this.type,
				};
				this.$router.replace({ query }).catch(() => {});
			},
			async paging(offset) {
				this.offset = offset;
				await this.setList();
				this.setQuery();
			},
			init() {
				this.setFilter();
				this.search();
			},
			search() {
				this.setList();
				this.setQuery();
			},
			async excelDown() {
				const { data } = await this.getList(true);
				const workbook = new Excel.Workbook();

				workbook.creator = '글로우픽';
				workbook.lastModifiedBy = '글로우픽';
				workbook.created = new Date();
				workbook.modified = new Date();
				const sheet = workbook.addWorksheet('one');
				sheet.columns = this.thBundle
					.reduce(
						(acc, list, idx) => [
							...acc,
							...list
								.filter(
									item =>
										item.text !== '상세보기' &&
										!item.colspan
								)
								.map(({ text }, idx2) =>
									idx === 1
										? idx2 < 2
											? `PUSH ${text}`
											: `알림함 ${text}`
										: text
								),
						],
						[]
					)
					.map((th, idx) => ({ header: th, key: idx }));
				sheet.addRows(
					data.map(itemList =>
						itemList
							.map(({ text }) => text)
							.slice(0, itemList.length - 1)
					)
				);

				const writeBuffer = await workbook.xlsx.writeBuffer();
				const blob = new Blob([writeBuffer], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				});
				const url = window.URL.createObjectURL(blob);
				const anchor = document.createElement('a');
				anchor.href = url;
				anchor.download = `푸시/알림함 통계(${moment(this.params.startAt, 'X').format('YYYY-MM-DD')} ~ ${moment(this.params.endAt, 'X').format('YYYY-MM-DD')})_${new Date().getTime()}.xlsx`;
				anchor.click();
				window.URL.revokeObjectURL(url);
				await this.$axiosSupport.post('/admin/admin_log', {
					admin_log: {
						path: this.$router.currentRoute.fullPath,
						action: 'CSV',
						doc: { 'api-url': this.lastUrl },
					},
				});
			},
		},
		computed: {
			thBundle() {
				return [
					[
						{
							text: '발송일',
							rowspan: 2,
							class: this.setCellClass('date'),
						},
						{
							text: '푸시항번',
							rowspan: 2,
							class: this.setCellClass('id'),
						},
						{
							text: '푸시&알림함 문구',
							rowspan: 2,
							class: this.setCellClass('content'),
						},
						{
							text: '구분',
							rowspan: 2,
							class: this.setCellClass('type'),
						},
						{
							text: '발송수',
							rowspan: 2,
							class: this.setCellClass('target'),
						},
						{
							text: '푸시타입',
							rowspan: 2,
							class: this.setCellClass('type'),
						},
						{
							text: 'PUSH',
							colspan: 2,
							class: this.setCellClass('device'),
						},
						{
							text: '알림함',
							colspan: 2,
							class: this.setCellClass('device'),
						},
						{
							text: '상세보기',
							rowspan: 2,
							class: this.setCellClass('detail'),
						},
					],
					[
						'열람 (AOS)',
						'열람 (IOS)',
						'열람 (AOS)',
						'열람 (IOS)',
					].map(text => ({
						text,
						class: this.setCellClass('dp-cnt'),
					})),
				];
			},
		},
		mounted() {
			this.setFilter(this.$route.query);
			this.setList();
		},
	};
</script>
<style lang="scss" scoped>
	.push-statistics {
		&__table {
			table-layout: fixed;
		}

		&__date-cell {
			width: 148px;
			padding: 0;
		}

		&__id-cell {
			width: 110px;
			padding: 0;
		}

		&__target-cell {
			width: 120px;
			padding: 0;
		}

		&__type-cell {
			width: 80px;
			padding: 0;
		}

		&__device-cell {
			width: 240px;
			padding: 0;
		}

		&__dp-cnt-cell {
			width: 120px;
			padding: 0;
		}

		&__detail-cell {
			width: 120px;
			padding: 0;
		}
	}
</style>
